<div class="empty-panel"></div>

<div class="side-panel">
    <div class="row">
        <div class="col title">
            <app-go-back></app-go-back>
            {{ "CampCareBooking.title" | translate }}
        </div>
    </div>

    <div class="voffset-20">
        @for (club of camp.clubsWithCampCareDays; track club) {
            <div
                class="club-btn"
                [ngClass]="{ 'club-btn-selected': isClubSelected(club) }"
                (click)="onSelectClub(club)"
            >
                {{ club.code }}
            </div>
        }
    </div>
</div>
